import './application.scss';

class Application {
    constructor (element, options) {
        // Default options
        const defaults = {
            initAttr: 'data-application'
        };

        // Settings
        this.settings = Object.assign({}, defaults, options);
        this.storedName = this.getDataFromSessionStorage('kuehne_career_personalized_name');

        // Elements
        this.$application = element;
        this.$firstNameInput = this.$application.querySelector('#job_application_apprenticeship_firstname');
    }

    initialize () {
        if (this.$firstNameInput && this.storedName !== null) {
            this.setStoredName();
        }
    }

    setStoredName () {
        this.$firstNameInput.value = this.storedName;
    }

    getDataFromSessionStorage (key) {
        const storedObject = sessionStorage.getItem(key);

        if (storedObject) {
            const object = JSON.parse(storedObject);
            console.log(object.value);
            return object.value;
        }

        return null; // No data found
    }
}

export { Application };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$application = $context.querySelectorAll('[data-application="root"]');
        for (let i = 0; i < $$application.length; i++) {
            const $application = $$application[i];

            const $applicationAPI = new Application($application);
            $applicationAPI.initialize();
        }
    }
});
